<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card class="mt-2 pb-8 mb-5" flat>
					<v-card-title>
						<v-subheader>
							<span class="title font-weight-normal">Filtrar avaliadores de contratos</span>
						</v-subheader>
						<v-spacer></v-spacer>
						<v-btn
							class="white--text mr-2"
							depressed
							color="#34bfa3"
							@click="$router.push('/contract-evaluator/new')"
							>+ Novo</v-btn
						>
						<v-btn class="white--text" depressed color="info" @click="filter()"
							>Buscar</v-btn
						>
						<search-filter-default v-model="filters" />
					</v-card-title>
				</v-card>
				<v-card flat>
					<v-data-table
						:headers="headers"
						:items="items"
						:items-per-page="pagination.itemsPerPage"
						v-bind:loading="loading"
						loading-text="Aguarde...carregando"
						:hide-default-footer="true"
					>
						<template v-slot:body="{ items }">
							<tr v-for="item in items" :key="item.GERCONAVALIADOR">
								<td>
									<v-btn
										@click="edit(item.GERCONAVALIADOR, user.CODUSU !== item.USUCAD)"
										icon
									>
										<v-icon
											style="color: orange"
											v-if="user.CODUSU === item.USUCAD"
											>mdi-pencil</v-icon
										>
										<v-icon v-else>mdi-eye</v-icon>
									</v-btn>
								</td>

								<td align="center">{{ item.user.NOMUSU }}</td>
								<td>{{ item.group.DESGRP }}</td>
								<td>{{ item.company.DESEMP }}</td>
								<td>{{ item.unit.DESUNI }}</td>
								<td align="center">{{ item.AVALIADOR ? "Sim" : "Não" }}</td>
							</tr>
						</template>
					</v-data-table>

					<pagination
						v-model="pagination"
						@change="loadData"
						:loading="loading"
					/>
				</v-card>
			</v-col>
		</v-row>
		<template>
			<Dialog ref="confirm" />
		</template>
	</v-container>
</template>

<script>
import SearchFilterDefault from "@/components/contract-evaluator/SearchFilterDefault.vue";
import pagination from "@/components/pagination/Pagination.vue";
import PaginationMixin from "@/components/pagination/PaginationMixin";
import ContractEvaluatorsService from "@/app/Services/ContractEvaluatorsService";
import Dialog from "../misc/Dialog";

export default {
	name: "ContractEvaluatorList",
	components: { Dialog, SearchFilterDefault, pagination },
	mixins: [PaginationMixin],
	mounted() {
		const userData = JSON.parse(localStorage.getItem("user"));

		if (userData && "user" in userData) {
			this.user = userData["user"];
		}
		this.loadData();
	},
	data: () => ({
		loading: false,
		filters: {},
		user: {},
		headers: [
			{
				text: "",
				align: "left",
				sortable: false,
				value: "status",
			},
			{
				text: "Código de usuário",
				align: "center",
				sortable: true,
				value: "CODUSU",
			},
			{
				text: "Grupo",
				align: "left",
				sortable: true,
				value: "CODGRP",
			},
			{
				text: "Empresa",
				align: "left",
				sortable: true,
				value: "CODEMP",
			},
			{
				text: "Filial",
				align: "left",
				sortable: true,
				value: "CODUNI",
			},
			{
				text: "Avaliador de contrato",
				align: "center",
				sortable: false,
				value: "AVALIADOR",
			},
		],
		items: [],
	}),
	methods: {
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon,
			});
		},
		async loadData() {
			try {
				this.loading = true;

				const filter = this.filters;

				const query = {
					params: {
						filter,
						...this.pagination,
					},
				};

				const response = await ContractEvaluatorsService.build().index({
					query,
				});

				this.items = response.data;
				this.loading = false;

				this.paginate(response);
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e);
				this.defaultCatchError(e);
			} finally {
				this.loading = false;
			}
		},
		filter() {
			this.searching = true;
			this.items = [];
			this.pagination.page = 1;

			this.loadData();
		},
		edit(id, view) {
			this.$router.push({
				name: "ContractEvaluatorsForm",
				params: {
					id: id,
					view: view,
				},
			});
		},
	},
};
</script>
